import { render } from "./RadioBox.vue?vue&type=template&id=a88b6b06&scoped=true"
import script from "./RadioBox.vue?vue&type=script&lang=js"
export * from "./RadioBox.vue?vue&type=script&lang=js"

import "./RadioBox.vue?vue&type=style&index=0&id=a88b6b06&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88b6b06"]])

export default __exports__